"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types;
(function (Types) {
    Types["SECONDARY"] = "isSecondary";
    Types["FULL"] = "isFull";
    Types["LINK"] = "isLink";
    Types["SMALL"] = "isSmall";
    Types["ROUND"] = "isRound";
    Types["SIMPLE"] = "isSimple";
})(Types = exports.Types || (exports.Types = {}));
